module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "about-bottom_img",
    staticStyle: {
      "position": "relative"
    }
  }, [(_vm.solutionlist.position1.length > 0) ? _c('img', {
    staticStyle: {
      "width": "100%",
      "height": "50vh"
    },
    attrs: {
      "src": _vm.solutionlist.position1[0].thumb
    }
  }) : _vm._e(), _vm._v(" "), (false) ? _c('p', {
    staticStyle: {
      "position": "absolute",
      "color": "#fff",
      "bottom": "10vh",
      "font-size": "6vh",
      "left": "12%",
      "border-bottom": "2px solid #ccc",
      "font-weight": "600"
    }
  }, [_vm._v(_vm._s(_vm.solutionlist.position1[0].title))]) : _vm._e()]), _vm._v(" "), _c('section', {
    staticClass: "banner-area"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 offset-xl-1 align-self-center"
  }, [_c('div', {
    staticClass: "banner-about color-about"
  }, [(_vm.solutionlist.position2.length > 0) ? _c('h2', {
    staticClass: "color-about",
    staticStyle: {
      "font-size": "2.5vh"
    }
  }, [_vm._v(_vm._s(_vm.solutionlist.position2[0].title))]) : _vm._e(), _vm._v(" "), _c('b', {
    staticClass: "slot-about"
  }), _vm._v(" "), (_vm.solutionlist.position2.length > 0) ? _c('p', {
    staticClass: "py-3",
    staticStyle: {
      "text-indent": "2em"
    }
  }, [_vm._v(_vm._s(_vm.solutionlist.position2[0].brief))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5 px-0",
    staticStyle: {
      "padding": "1px"
    }
  }, [(_vm.solutionlist.position2.length > 1) ? _c('img', {
    staticStyle: {
      "width": "100%",
      "height": "40vh"
    },
    attrs: {
      "src": _vm.solutionlist.position2[1].thumb,
      "alt": ""
    }
  }) : _vm._e()]), _vm._v(" "), _vm._m(0)])])]), _vm._v(" "), _c('section', {
    staticClass: "feature-area section-padding2"
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.solutionlist.position3.length > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "section-top text-center"
  }, [_c('h4', {
    staticClass: "color-about"
  }, [_vm._v(" " + _vm._s(_vm.solutionlist.position3[0].title))]), _vm._v(" "), _c('p', {
    staticClass: "py-3 text-left color-about",
    staticStyle: {
      "font-style": "unset",
      "text-indent": "2em"
    }
  }, [_vm._v(_vm._s(_vm.solutionlist.position3[0].brief) + "\n            ")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-8"
  }, [(_vm.solutionlist.position3.length > 1) ? _c('div', {
    staticClass: "single-feature mb-4 mb-lg-0",
    style: ({
      backgroundImage: 'url(' + _vm.solutionlist.position3[1].thumb + ')',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center center',
      backgroundSize: 'cover',
      height: '20vh'
    })
  }, [_c('h4', {
    staticClass: "color-about-foot"
  }, [_vm._v(_vm._s(_vm.solutionlist.position3[1].title))]), _vm._v(" "), _c('p', {
    staticClass: "py-0 color-about-foot"
  }, [_vm._v(_vm._s(_vm.solutionlist.position3[1].brief))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [(_vm.solutionlist.position3.length > 2) ? _c('div', {
    staticClass: "single-feature mb-4 mb-lg-4",
    style: ({
      backgroundImage: 'url(' + _vm.solutionlist.position3[2].thumb + ')',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center center',
      backgroundSize: 'cover',
      height: '20vh'
    })
  }, [_c('h4', {
    staticClass: "color-about-foot"
  }, [_vm._v(_vm._s(_vm.solutionlist.position3[2].title))]), _vm._v(" "), _c('p', {
    staticClass: "py-0 color-about-foot"
  }, [_vm._v(_vm._s(_vm.solutionlist.position3[2].brief))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.solutionlist.position3.length > 3) ? _c('div', {
    staticClass: "col-lg-4"
  }, [_c('div', {
    staticClass: "single-feature mb-4 mb-lg-4",
    style: ({
      backgroundImage: 'url(' + _vm.solutionlist.position3[3].thumb + ')',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center center',
      backgroundSize: 'cover',
      height: '20vh'
    })
  }, [_c('h4', {
    staticClass: "color-about-foot"
  }, [_vm._v(_vm._s(_vm.solutionlist.position3[3].title))]), _vm._v(" "), _c('p', {
    staticClass: "py-0 color-about-foot"
  }, [_vm._v(_vm._s(_vm.solutionlist.position3[3].brief))])])]) : _vm._e(), _vm._v(" "), (_vm.solutionlist.position3.length > 4) ? _c('div', {
    staticClass: "col-lg-4"
  }, [_c('div', {
    staticClass: "single-feature mb-4 mb-lg-4",
    style: ({
      backgroundImage: 'url(' + _vm.solutionlist.position3[4].thumb + ')',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center center',
      backgroundSize: 'cover',
      height: '20vh'
    })
  }, [_c('h4', {
    staticClass: "color-about-foot"
  }, [_vm._v(_vm._s(_vm.solutionlist.position3[4].title))]), _vm._v(" "), _c('p', {
    staticClass: "py-0 color-about-foot"
  }, [_vm._v(_vm._s(_vm.solutionlist.position3[4].brief))])])]) : _vm._e(), _vm._v(" "), (_vm.solutionlist.position3.length > 5) ? _c('div', {
    staticClass: "col-lg-4"
  }, [_c('div', {
    staticClass: "single-feature mb-4 mb-lg-4",
    style: ({
      backgroundImage: 'url(' + _vm.solutionlist.position3[5].thumb + ')',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center center',
      backgroundSize: 'cover',
      height: '20vh'
    })
  }, [_c('h4', {
    staticClass: "color-about-foot"
  }, [_vm._v(_vm._s(_vm.solutionlist.position3[5].title))]), _vm._v(" "), _c('p', {
    staticClass: "py-0 color-about-foot"
  }, [_vm._v(_vm._s(_vm.solutionlist.position3[5].brief))])])]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-11 offset-xl-1"
  }, [_c('div', {
    staticClass: "foot-banner"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44aa54ae"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/About.vue
// module id = 291
// module chunks = 1